import Grid from '../components/grid'
import Container from '../components/ui/container'
import Text from '../components/ui/text'
import { Asset } from '../v2/components/Asset'
import { Page, Asset as AssetT, Resource, Form } from '@telesoft/types/payload-types'
import React, { ReactElement } from 'react'
import { CMSLink } from '../v2/components/CMSLink'
import { RichText } from '../v2/components/RichText'
import { RESOURCE_URL } from '@telesoft/lib/web/constants'
import ModalForm from '../v2/components/ModalForm'
import { Button } from '../v2/components/ui/button'

export type SnippetsInfoImageBlockProps = Extract<
  Page['blocks'][0],
  { blockType: 'snippets-info-image' }
>

export default function SnippetsInfoImage(block: SnippetsInfoImageBlockProps): ReactElement {
  const { variant, description, title, snippets, image, cta } = block
  const { link } = cta

  const hasDownloadableResource: boolean = link.reference?.relationTo === 'resources'
  const resource = link?.reference.value as Resource | undefined
  const isResourceWalled = resource?.isWalled
  const downloadUrl = RESOURCE_URL + '/' + resource?.filename

  return (
    <Container>
      <Grid>
        <div className="col-span-full lg:col-span-6 border-t pt-4 md:pt-8 lg:pt-10 border-heading">
          {variant === 'description' && (
            <Text className="mb-6 whitespace-pre-wrap" variant="body">
              <RichText className="text-black" content={description} />
            </Text>
          )}

          {variant === 'snippet' && (
            <Text className="mb-6 lg:mb-8 sm:max-w-xs md:max-w-lg" variant="subHeading">
              {title}
            </Text>
          )}

          {variant === 'snippet' &&
            snippets &&
            snippets.map((snippet: any, i: number) => {
              return (
                <div
                  key={`snippet-description-map--${i}`}
                  className="flex flex-col sm:max-w-xs md:max-w-lg mb-6 lg:mb-8"
                >
                  <Text variant="heading" className="mb-1">
                    {snippet.title}
                  </Text>
                  <Text>
                    <RichText content={snippet.description} />
                  </Text>
                </div>
              )
            })}
        </div>

        <div className="group relative col-span-full lg:col-span-6 min-h-[280px] md:[min-h-300px] lg:min-h-[420px]">
          <div className="z-20 lg:border-t md:max-w-md lg:max-w-max xl:max-w-md lg:border-white p-8 lg:p-0 lg:pt-8 absolute inset-0  md:bottom-8 md:right-8 lg:bottom-auto lg:left-8 lg:right-8 lg:top-8 xl:left-auto xl:right-8 xl:top-auto xl:bottom-8 flex flex-col justify-start items-start">
            <Text variant="mediumHeading" className="text-white mb-4">
              {cta.title}
            </Text>
            {cta.description && <Text className="text-white opacity-70">{cta.description}</Text>}
            {hasDownloadableResource && isResourceWalled ? (
              <ModalForm
                cmsForm={resource.form as Form}
                formMessage={`Download ${resource.name}`}
                buttonLabel={link.label}
                resourceID={resource.id}
                buttonProps={{
                  className: 'mt-5',
                  inverted: true,
                  // variant: options?.color === 'bg-telesoft' ? 'outline' : 'default',
                }}
              />
            ) : hasDownloadableResource && (
              <Button asChild inverted className="text-white" variant={'default'}>
                <a href={downloadUrl} target="_blank">
                  Download Now
                </a>
              </Button>
            )}
            {!hasDownloadableResource && (
              <CMSLink
                buttonProps={{
                  className: 'border-white',
                  inverted: true,
                }}
                className="mt-5"
                showLabel={false}
                {...link}
              >
                <div className="text-white">{link.label}</div>
              </CMSLink>
            )}
          </div>

          <div className="absolute inset-0 z-10 bg-gradient-to-t from-black to-transparent opacity-80" />
          <Asset resource={image as AssetT} imgClassName={`object-cover object-center`} fill />
        </div>
      </Grid>
    </Container>
  )
}
